import {
  DEFAULT_BLACK_IMAGE_PATH,
} from '../../../scripts/Routes/images.js';

export const coursesAcademicProjects = [
  {
    'src': DEFAULT_BLACK_IMAGE_PATH,
    'text': 'Zero to Hero',
    'date': 'March 2023',
    'url': '#',
  },
  {
    'src': DEFAULT_BLACK_IMAGE_PATH,
    'text': 'Deep Learning A-Z',
    'date': 'May 2022',
    'url': '#',
  },
  {
    'src': DEFAULT_BLACK_IMAGE_PATH,
    'text': 'Intro to Machine Learning - Andrew Ng',
    'url': '#',
  },
  {
    'src': DEFAULT_BLACK_IMAGE_PATH,
    'text': 'Machine Learning Case Studies - Univ Of Washington',
    'url': '#',
  },
  {
    'src': DEFAULT_BLACK_IMAGE_PATH,
    'text': 'Advanced React and GraphQL - Wes Bos',
    'url': '#',
  },
  {
    'src': DEFAULT_BLACK_IMAGE_PATH,
    'text': 'Machine Learning A-Z',
    'date': 'August 2022',
    'url': '#',
  },
];
